import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Side-by-side feet + inches picker with matching range sliders.
 * Used by the Medical Questionnaire's "Personal Information" step.
 */
export default function HeightPicker({ feet, inches, onFeetChange, onInchesChange }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label className="text-sm font-bold text-slate-700 mb-2 block">Feet</Label>
        <Input
          type="number"
          inputMode="numeric"
          min={3}
          max={8}
          value={feet}
          onChange={(e) => onFeetChange(e.target.value)}
          placeholder="5"
          className="rounded-xl h-14 text-2xl font-bold text-center border-2 border-slate-200 focus:border-purple-500"
          data-testid="q-height-feet"
        />
        <input
          type="range"
          min={3}
          max={8}
          value={feet || 5}
          onChange={(e) => onFeetChange(e.target.value)}
          className="mt-2 w-full accent-purple-600"
          data-testid="q-height-feet-slider"
        />
      </div>
      <div>
        <Label className="text-sm font-bold text-slate-700 mb-2 block">Inches</Label>
        <Input
          type="number"
          inputMode="numeric"
          min={0}
          max={11}
          value={inches}
          onChange={(e) => onInchesChange(e.target.value)}
          placeholder="8"
          className="rounded-xl h-14 text-2xl font-bold text-center border-2 border-slate-200 focus:border-purple-500"
          data-testid="q-height-inches"
        />
        <input
          type="range"
          min={0}
          max={11}
          value={inches || 0}
          onChange={(e) => onInchesChange(e.target.value)}
          className="mt-2 w-full accent-purple-600"
          data-testid="q-height-inches-slider"
        />
      </div>
    </div>
  );
}
